'use client';

import { heliosSizes } from '~/constants/common/resizeBreakpoints';
import useResizeListener from '~/hooks/common/ui/useResizeListener';

export default function NotFoundDeviceSync() {
  useResizeListener(heliosSizes);

  return null;
}
